export const AVAILABLE_USER_ROLES = [
  { value: 'ROLE_USER', label: 'Utilisateur', badge: 'info', system: true },
  { value: 'ROLE_COMMERCIAL', label: 'Commercial', badge: 'success', system: true },
  { value: 'ROLE_ADMIN_COMMERCIAL', label: 'Admin commercial', badge: 'warning', system: true },
  { value: 'ROLE_TM_PROJECT_MANAGER', label: 'Gestionnaire de projets', badge: 'primary', system: true },
  { value: 'ROLE_RESPONSABLE_MAG', label: 'Responsable mag', badge: 'danger', system: true },
  { value: 'ROLE_GRAPHISTE', label: 'Graphiste', badge: 'secondary', system: true },
  { value: 'ROLE_PROD', label: 'Production', badge: 'info', system: true },
  { value: 'ROLE_ADMIN', label: 'Administrateur', badge: 'warning', system: true },
  { value: 'ROLE_SUPERADMIN', label: 'Super Administrateur', badge: 'danger', system: true },
];

/** Rôles configurables dans la matrice de visibilité (hors Superadmin). */
export const MATRIX_USER_ROLES = AVAILABLE_USER_ROLES.filter(
  (role) => role.value !== 'ROLE_SUPERADMIN',
);

const ROLE_LABELS = Object.fromEntries(
  AVAILABLE_USER_ROLES.map((role) => [role.value, role.label])
);

export { ROLE_LABELS };

const ROLE_BADGE_VARIANTS = {
  ROLE_SUPERADMIN: 'danger',
  ROLE_ADMIN: 'warning',
  ROLE_RESPONSABLE_MAG: 'danger',
  ROLE_ADMIN_COMMERCIAL: 'warning',
  ROLE_COMMERCIAL: 'success',
  ROLE_TM_PROJECT_MANAGER: 'primary',
  ROLE_GRAPHISTE: 'secondary',
  ROLE_PROD: 'info',
  ROLE_USER: 'info',
};

/** Catalogue courant (système + rôles créés en admin). */
let runtimeRoles = AVAILABLE_USER_ROLES;

export function setRuntimeUserRoles(roles) {
  runtimeRoles = Array.isArray(roles) && roles.length > 0 ? roles : AVAILABLE_USER_ROLES;
}

export function getAvailableUserRoles() {
  return runtimeRoles;
}

export function getRoleLabel(role) {
  const found = runtimeRoles.find((item) => item.value === role);
  return found?.label || ROLE_LABELS[role] || role;
}

export function getRoleBadgeVariant(role) {
  const found = runtimeRoles.find((item) => item.value === role);
  return found?.badge || ROLE_BADGE_VARIANTS[role] || 'info';
}

/** Rôles à afficher : tous, sauf ROLE_USER s'il est implicite (d'autres rôles sont présents). */
export function getDisplayRoles(roles = []) {
  const unique = [...new Set(roles)];
  const catalog = getAvailableUserRoles();
  const ordered = catalog
    .map((role) => role.value)
    .filter((value) => unique.includes(value));
  const extras = unique.filter((value) => !ordered.includes(value));
  const display = [...ordered, ...extras];

  if (display.length > 1) {
    return display.filter((value) => value !== 'ROLE_USER');
  }

  return display.length > 0 ? display : ['ROLE_USER'];
}

export function getDisplayRoleLabels(roles = []) {
  return getDisplayRoles(roles).map(getRoleLabel).join(', ');
}
